import { App, CDN, CONFIG, DOMAIN } from 'config';
import { t } from 'zf-web-components';
import type { LocalStore } from 'zf-web-infra';

export class ThemeService {

  private readonly local: LocalStore;
  constructor(local: LocalStore) {
    this.local = local;
  }

  /**
   * 用域名识别应用
   */
  getAppFromHostName(hostname: string): string {
    if (this.local.app != null) {
      return this.local.app;
    }
    if (DOMAIN[hostname] != null) {
      return DOMAIN[hostname];
    }
    return process.env.DEFAULT_APP as string;
  }

  getFavicon(): string {
    const app = this.getAppFromHostName(location.hostname);
    return `${CDN}/microapp/${app}_favicon.ico`;
  }

  getAppName(): string {
    const app = this.getAppFromHostName(location.hostname);
    if (app === App.MARKETING) {
      return t('Marketing BI');
    }
    if (app === App.TRAINING) {
      return t('训练助手');
    }
    if (app === App.DETECTIVE) {
      return t('神访助手');
    }
    if (app === App.ADMIN) {
      return t('管理后台');
    }
    if (app === App.SHOTEYES) {
      return t('巡店助手');
    }
    if (app === App.SHIFTPLAN) {
      return t('排班助手');
    }
    return '';
  }

  getAppDescription(): string {
    const app = this.getAppFromHostName(location.hostname);
    if (app === App.MARKETING) {
      return t('经营分析 - 洞察餐饮门店经营数据，让营销效果清晰可见');
    }
    if (app === App.TRAINING) {
      return t('训练助手 - 连锁门店人才训练培养体系。');
    }
    if (app === App.DETECTIVE) {
      return t('神访助手 - 倾听来自客户的心声。');
    }
    if (app === App.ADMIN) {
      return t('管理后台');
    }
    if (app === App.SHOTEYES) {
      return t('巡店助手 - 专注连锁店标准化运营管理，重塑连锁总部和门店的连接，帮助企业提升连锁店一线服务团队执行力和运营管理水平。');
    }
    if (app === App.SHOTEYES) {
      return t('排班助手 - 帮助企业提升员工排班管理能力。');
    }
    return '';
  }

  getAppKeyword(): string {
    return '巡店助手,巡店系统,ShotEyes,Alphabets,字符科技,字小符科技,巡店,督导管理,连锁,标准化,门店运营管理,小程序,经营分析,训练助手,排班助手';
  }

  getPrimaryColor(): string {
    const app = this.getAppFromHostName(location.hostname);
    if (app === App.MARKETING) {
      return '#024FA2';
    }
    if (app === App.TRAINING) {
      return '#00ADB5';
    }
    if (app === App.SHOTEYES) {
      return '#E44134';
    }
    if (app === App.SHIFTPLAN) {
      return '#E75B1B';
    }
    return '#E44134';
  }

  getLogo(): string {
    const app = this.getAppFromHostName(location.hostname);
    if (app === App.MARKETING) {
      return `${CONFIG.IMAGE_STATIC}/analyze_logo@2x.png`;
    }
    if (app === App.TRAINING) {
      return `${CONFIG.IMAGE_STATIC}/training_logo@2x.png`;
    }
    if (app === App.DETECTIVE) {
      return `${CONFIG.IMAGE_STATIC}/detective_logo@2x.png`;
    }
    if (app === App.SHOTEYES) {
      return `${CONFIG.IMAGE_STATIC}/shoteyes_logo@2x.png`;
    }
    if (app === App.SHIFTPLAN) {
      return `${CONFIG.IMAGE_STATIC}/shiftplan_logo@2x.png`;
    }
    return `${CONFIG.IMAGE_STATIC}/shoteyes_logo@2x.png`;
  }

  getFontFamily(): string[] {
    return [
      'PingFang SC',
      'Microsoft YaHei',
      '-apple-system',
      'BlinkMacSystemFont',
      'Segoe UI',
      'Roboto',
      'Helvetica Neue',
      'Arial',
      'Noto Sans',
      'sans-serif',
      'Apple Color Emoji',
      'Segoe UI Emoji',
      'Segoe UI Symbol',
      'Noto Color Emoji'
    ];
  }

}
